import { PageTypeEnum } from '@/constant';
import { useRowSelection, useToggle } from '@/hooks';
import {
	CommonSelectors,
	WorkerProgramActions,
	WorkerProgramSelectors,
} from '@/stores';
import { WorkerApplicantActions } from '@/stores/worker-applicant';
import { showAlert } from '@/utils';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isNotNilOrEmpty } from 'ramda-adjunct';

import { getColumns, TriggerOpenJoinProgramModal } from './config';
import { JoinProgramModalViewProps } from './type';

export const useLogic = (props: JoinProgramModalViewProps) => {
	const rowSelection = useRowSelection({
		type: 'radio',
	});

	const headerProgram = useSelector(CommonSelectors.selectHeaderProgram);

	const dataSource = useSelector(
		WorkerProgramSelectors.selectWorkerProgramAllList
	);
	const columns = useMemo(
		() => getColumns(dataSource.length),
		[dataSource.length]
	);
	const dispatch = useDispatch();
	const {
		listIds,
		nameApplicant,
		pageType,
		callbackFetchingDataProgramApplicant,
	} = props;

	const [openModal, onToggle] = useToggle(false);

	useEffect(() => {
		TriggerOpenJoinProgramModal.show = onToggle;
	}, []);

	useEffect(() => {
		if (!openModal) return;
		dispatch(WorkerProgramActions.getWorkerProgramAllListRequest());

		return () => {
			rowSelection.onReset();
		};
	}, [openModal]);

	useEffect(() => {
		if (headerProgram?.value) {
			rowSelection.setState({
				selectedRowKeys: [headerProgram.value] as number[],
				selectedRows: [],
			});
		}
	}, [headerProgram, openModal]);

	const handleSave = useCallback(() => {
		if (isNotNilOrEmpty(rowSelection.selectedRowKeys)) {
			switch (pageType) {
				case PageTypeEnum.APPLICANT:
					dispatch(
						WorkerApplicantActions.createWorkerApplicantProgramRequest({
							applicantIds: listIds || [],
							programId: Number(rowSelection?.selectedRowKeys[0]),
							callback: () => {
								callbackFetchingDataProgramApplicant?.({ page: 1 });
							},
						})
					);
					break;
				default:
					break;
			}
		} else {
			showAlert('프로그램을(를) 선택해주세요.');
			onToggle();
		}
		onToggle();
	}, [
		onToggle,
		rowSelection.selectedRowKeys,
		callbackFetchingDataProgramApplicant,
	]);

	return {
		openModal,
		dataSource,
		columns,
		rowSelection,
		nameApplicant,
		listIds,

		onToggle,
		handleSave,
	};
};
